import ShButton from '@/components/Helpers/ShButton';

// @vue/component
export default {
  name: 'PermissionProfilesProfile',

  components: { ShButton },

  props: {
    profile: {
      type: Object,
      default: () => ({}),
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    editProfile() {
      this.$emit('setProfile', this.profile);
      this.$emit('editProfile', this.profile);
    },
  },
};
